import { gsap } from 'gsap'

let screenWidth = window.innerWidth
let screenHeight = window.innerHeight
if (screenWidth > 1920) {
  let fontCoef = screenWidth / 1440
  let fontSize = Math.floor(16 * fontCoef)
  fontSize = fontSize > 32 ? 32 : fontSize

  $('html').css('font-size', fontSize + 'px')
}
if(screenWidth > 1000 && screenHeight < 720) {
  let fontSize = 14
  $('html').css('font-size', fontSize + 'px')
}


gsap.config({
  force3D: false,
  nullTargetWarn: false
})

setTimeout(function (){
  $('body').removeAttr('style')
}, 50)
